import { render, staticRenderFns } from "./k-code-editor.vue?vue&type=template&id=3e5513d7&"
import script from "./k-code-editor.vue?vue&type=script&lang=js&"
export * from "./k-code-editor.vue?vue&type=script&lang=js&"
import style0 from "./k-code-editor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports